import AchatsDashboard from '@features/achats/components/AchatsDashboard'
import { PERMISSIONS } from '@lib/permissions/permissions.generated'
import { createFileRoute } from '@tanstack/react-router'
import { ShoppingCart } from 'lucide-react'

export const Route = createFileRoute('/_app/achats/')({
  staticData: {
    title: 'Achats',
    icon: ShoppingCart,
    tab_icon: ShoppingCart,
    permission: PERMISSIONS.ACHATS.FOURNISSEURS.VIEW,
    section: 'Achats',
    order: 30,
    description: 'Module Achats',
    module: 'achats',
    showInTab: true,
    showInNav: true,
    showInBreadcrumb: true,
  },
  component: AchatsDashboard,
})
